import { Grid, Typography } from 'material-ui'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { ClientQuote } from '../components/ClientQuote'
import { Footer } from '../components/Footer'
import { ProjectSelectorCard, ProjectSelectorTitle } from '../components/ProjectSelectorCard'
import { SpreadBody } from '../components/SpreadBody'
import { AsideBox } from './AsideBox'
import { MainBlurb } from './MainBlurb'
import { TitleSpread, TitleSpreadBody, TitleSpreadContent } from './TitleSpread'

interface Props {}

interface State {

}

export class AvantStory extends React.Component<RouteComponentProps<Props, {}>, State> {
    componentDidMount() {
        window.scroll(0, 0)
    }

    AvantTitleSpread = () => {
        return (
            <TitleSpread
                img='/img/avant-story/avant-blue-photo-bg.png'
                color='#36426a'
                goBack={() => this.props.router.push('/')}
            >
                <TitleSpreadBody>
                    <TitleSpreadContent extraLargeTitle title='Avant Assessment' sub='Partner Story'>
                        Twenty Ideas partners with Avant Assessment to provide full-service technology,
                        design and development services which support, sustain, and grow Avant’s vision
                        to become a world-wide leader in language assessment and learning.
                    </TitleSpreadContent>
                </TitleSpreadBody>
            </TitleSpread>
        )
    }

    CreatingAccuracySpread = () => {
        return (
            <SpreadBody>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Creating Accuracy through AI'>
                            Twenty Ideas improved the accuracy of Avant’s most crucial grading process: writing.
                            We were able to leverage AI to create a learning algorithm which can grade writing
                            assessments with better statistical significance than human graders. That’s right -
                            better than human graders.
                        </MainBlurb>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <AsideBox
                            greyBg
                            title='Powered by Analytic Spot'
                            linkText='Learn more about Analytic Spot'
                            href='http://analyticspot.com/'
                        >
                            Powered by Twenty Ideas's AI service, Analytic Spot, we were able to improve
                            the accuracy of written responses on assessments at Avant Assessment.
                        </AsideBox>

                    </Grid>

                    <Grid item xs={12}>
                        <img
                            src='/img/avant-story/creating-accuracy-graphic.png'
                            width={'100%'}
                            style={{marginTop: 40}}
                            alt='accuracy-graphic'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    LearningWriteSpread = () => {
        return (
            <SpreadBody greyBg>
                <Grid container spacing={8}>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Forging new products: LearningWrite'>
                            Leveraging our writing AI tool, we partnered with Avant to forge a new, innovative writing
                            experience that helps teachers improve writing. Offering an efficient ecosystem to assign
                            tasks and auto-correct written responses, LearningWrite marries polished UX with
                            cutting-edge AI.
                        </MainBlurb>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <AsideBox
                            title={(
                                <span>
                                    Check out
                                    <img
                                        src='/img/avant-story/lw-logo.png'
                                        alt='learningwrite'
                                        style={{
                                            height: 25,
                                            marginLeft: 10,
                                            position: 'relative',
                                            top: 6
                                        }}
                                    />
                                </span>
                            )}
                            linkText='Visit LearningWrite.com'
                            href='http://learningwrite.com/'
                        >
                            Powered by Twenty Ideas's AI service, Analytic Spot, we are able to save teachers
                            time that they can spend with students on other activities.
                        </AsideBox>

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/avant-story/learningwrite-graphic-1.png'
                            width={'100%'}
                            style={{marginBottom: 0}}
                            alt='redesign-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/avant-story/learningwrite-graphic-2.png'
                            width={'100%'}
                            style={{marginBottom: 5}}
                            alt='redesign-graphic'
                        />
                        <img
                            src='/img/avant-story/learningwrite-graphic-3.png'
                            width={'100%'}
                            style={{marginBottom: 5}}
                            alt='redesign-graphic'
                        />
                        <img
                            src='/img/avant-story/learningwrite-graphic-4.png'
                            width={'100%'}
                            style={{marginBottom: 0}}
                            alt='redesign-graphic'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    BongQuote = () => {
        return (
            <SpreadBody>
                <ClientQuote
                    clientName='David Bong'
                    clientTitle='CEO, Avant Assessment'
                    clientImg='/img/headshots/bong.png'
                    quote={'"The Twenty Ideas team has become part of the Avant family, ' +
                    'bringing integral value to our mission."'}
                />
            </SpreadBody>
        )
    }

    UnifiedPlatform = () => {
        return (
            <SpreadBody greyBg>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Creating a Unified Platform'>
                            Of all our activities with Avant, our guiding mission has been to continually improve
                            Avant's core technology and infrastructure. Every project is an opportunity to consolidate
                            code, streamline systems, cut costs, while still exceptionally executing on that project.
                        </MainBlurb>
                    </Grid>
                </Grid>
                {/*<Grid container>*/}
                {/*<Grid item xs={12} sm={6}>*/}
                {/*<img*/}
                {/*src='/img/avant-story/avant-unified-1.png'*/}
                {/*width={'100%'}*/}
                {/*style={{marginBottom: 5}}*/}
                {/*alt='unified-graphic'*/}
                {/*/>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12} sm={6}>*/}
                {/*<img*/}
                {/*src='/img/avant-story/avant-unified-2.png'*/}
                {/*width={'100%'}*/}
                {/*style={{marginBottom: 5}}*/}
                {/*alt='unified-graphic'*/}
                {/*/>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12} sm={6}>*/}
                {/*<img*/}
                {/*src='/img/avant-story/avant-unified-3.png'*/}
                {/*width={'100%'}*/}
                {/*style={{marginBottom: 5}}*/}
                {/*alt='unified-graphic'*/}
                {/*/>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12} sm={6}>*/}
                {/*<img*/}
                {/*src='/img/avant-story/avant-unified-4.png'*/}
                {/*width={'100%'}*/}
                {/*style={{marginBottom: 5}}*/}
                {/*alt='unified-graphic'*/}
                {/*/>*/}
                {/*</Grid>*/}
                {/*</Grid>*/}
            </SpreadBody>
        )
    }

    NewProductsSpread = () => {
        return (
            <SpreadBody>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='New products, Short Timelines:  AvantAdvance & APT'>
                            Along with improving Avant’s existing technology stack to make them more efficient and
                            nimble, Twenty Ideas has helped them envision new products, including training software, and
                            their first learning application: LearningWrite.
                        </MainBlurb>
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/avant-story/new-products-graphic-1.png'
                            width={'100%'}
                            alt='redesign-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/avant-story/new-products-graphic-2.png'
                            width={'100%'}
                            alt='redesign-graphic'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    DeepIntegrationSpread = () => {
        return (
            <SpreadBody greyBg>
                <Grid container>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Deep integration for deeper relationships and results.'>
                            TwentyIdeas is more than a partner. We’re a part of Avant’s team. We provide daily and
                            dedicated staffing, so that Avant technology systems can stay online, and continuously be
                            improved through a direct relationship with all of Avant’s internal team members. We call it
                            “deep integration.”
                        </MainBlurb>
                    </Grid>
                </Grid>
                <Grid container spacing={16}>
                    <Grid item xs={12} sm={7}>
                        <div
                            style={{
                                background: 'url("/img/avant-story/deep-graphic-1.png")',
                                height: 470,
                                width: '100%',
                                backgroundSize: 'cover'
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <div
                            style={{
                                background: 'url("/img/avant-story/deep-graphic-2.png")',
                                height: 470,
                                width: '100%',
                                backgroundSize: 'cover'
                            }}
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    WebsiteRedesign = () => {
        return (
            <SpreadBody bottom={30}>
                <Grid container spacing={8}>
                    <Grid item xs={12} md={7}>
                        <MainBlurb title='Website Refresh'>
                            Re-envisioning Avant's website presence, Twenty Ideas designed and built a new site from the
                            ground up. By using a modern content management system (CMS), Avant administrators can
                            directly add and modify content.
                        </MainBlurb>
                    </Grid>
                    <Grid item xs={12}>
                        <img
                            src='/img/avant-story/website-redesign-graphic-1.png'
                            width={'100%'}
                            alt='redesign-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/avant-story/website-redesign-graphic-2.png'
                            width={'100%'}
                            alt='redesign-graphic'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <img
                            src='/img/avant-story/website-redesign-graphic-3.png'
                            width={'100%'}
                            alt='redesign-graphic'
                        />
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    OtherStories = () => {
        return (
            <SpreadBody top={30}>
                <Typography type='display1' style={{margin: '20px 0px', fontWeight: 500}}>
                    See our other partner stories
                </Typography>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <ProjectSelectorCard
                            img='/img/partner-link-photo-green.png'
                            color='#36426a'
                            height={270}
                            onClick={() => this.props.router.push('/random-lengths')}
                        >
                            <ProjectSelectorTitle title='Random Lengths' sub='Partner Story'/>
                        </ProjectSelectorCard>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ProjectSelectorCard
                            img='/img/xprize-link-photo-gold.png'
                            color='#36426a'
                            height={270}
                            onClick={() => this.props.router.push('/xprize')}
                        >
                            <ProjectSelectorTitle title='XPRIZE' sub='Partner Story'/>
                        </ProjectSelectorCard>
                    </Grid>
                </Grid>
            </SpreadBody>
        )
    }

    render() {

        const {
            AvantTitleSpread,
            LearningWriteSpread,
            CreatingAccuracySpread,
            WebsiteRedesign,
            BongQuote,
            NewProductsSpread,
            DeepIntegrationSpread,
            UnifiedPlatform,
            OtherStories
        } = this

        return (
            <div>
                <AvantTitleSpread/>
                <CreatingAccuracySpread/>
                <LearningWriteSpread/>
                <BongQuote/>
                <UnifiedPlatform/>
                <NewProductsSpread/>
                <DeepIntegrationSpread/>
                <WebsiteRedesign/>
                <OtherStories/>
                <Footer accent navigateTo={this.props.router.push}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/stories/AvantStory.tsx